import {useCallback, useInsertionEffect, useRef} from 'react';

/**
 * Creates a stable but never stale function that can be passed as a prop to
 * child components or used in effects for event-like behavior.
 *
 * @param fn - The callback function to make stable.
 * @returns A stable callback function.
 */
export function useStableCallback<Args extends unknown[], Return>(
    fn: (...args: Args) => Return,
) {
    const ref = useRef<((...args: Args) => Return) | null>(null);

    useInsertionEffect(() => {
        ref.current = fn;
    }, [fn]);

    return useCallback((...args: Args) => {
        const f = ref.current!;
        return f(...args);
    }, []);
}
